import { isPresent } from "@apl-digital/utils";

import { hasData } from "@/store/apiRequestStatusMachine";
import { selectShoppingCart } from "@/store/shoppingCart";
import type { RootState } from "@/store/slices";

import { selectTheatreResource } from "./slice";

export const selectIsTheatreResourceBound = (state: RootState) => {
  const shoppingCart = selectShoppingCart(state);
  const expectedTheatreResource = selectTheatreResource(state);

  if (
    !hasData(expectedTheatreResource) ||
    !hasData(shoppingCart) ||
    !isPresent(shoppingCart.state.Defaults?.TheatreResourceID)
  ) {
    return false;
  }

  return (
    shoppingCart.state.Defaults.TheatreResourceID ===
    expectedTheatreResource.state.ID
  );
};
